// Live catalog store.
// Filled by index.js bootstrap (from GET /api/catalog/bootstrap) BEFORE App —
// and therefore mock.js — is imported, so mock.js's synchronous derived
// exports (PRODUCTS, COLLECTIONS, COLLECTIONS_BY_BRAND, ...) see live data.
// The bundled JSON is retained ONLY as an offline/fallback (API down, or the
// SEO prerender pass where the API may be unreachable).
import collectionsFallback from './data/collections.json';
import productsFallback from './data/products.json';

let _products = productsFallback;
let _collections = collectionsFallback;
let _source = 'fallback';

export const setCatalog = (products, collections) => {
  if (Array.isArray(products) && products.length) _products = products;
  if (Array.isArray(collections) && collections.length) _collections = collections;
  _source = 'api';
};

export const getProducts = () => _products;
export const getCollections = () => _collections;
export const getCatalogSource = () => _source;
